{
  "version": 1,
  "asset_id": "f36c1d9b-113f-484d-a556-52340df2fc29",
  "project_id": "1203040e-940d-4f2e-ab5b-8733ed2d3c31",
  "url": "/__l5e/assets-v1/f36c1d9b-113f-484d-a556-52340df2fc29/opt_metodo-3.jpg",
  "r2_key": "a/v1/1203040e-940d-4f2e-ab5b-8733ed2d3c31/f36c1d9b-113f-484d-a556-52340df2fc29/opt_metodo-3.jpg",
  "original_filename": "opt_metodo-3.jpg",
  "size": 90763,
  "content_type": "image/jpeg",
  "created_at": "2026-08-26T20:33:28Z"
}
